import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';
import {differenceInYears} from 'date-fns';
import {
  Claim,
  ClaimIdCard,
  ClaimSelf,
  ClaimSelfForAdmin,
  ScanBadgeData
} from '../../../shared/models/claim';
import {Country, envCountries} from '../../../shared/models/countries';
import {ApiService} from '../../../shared/services/api.service';
import {ScanService} from '../../../shared/services/scan.service';
import {BlockArray, DevicesService, LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {PersonnalDatasService} from 'src/app/shared/services/personnal-datas.service';
import {environment} from 'src/environments/environment';
import {SyncService} from '../../../shared/services/sync.service';
import {Place} from '../../../shared/models/place';
import {ScreenOrientation, OrientationType} from '@capawesome/capacitor-screen-orientation';

@Component({
  selector: 'app-scan-result',
  templateUrl: './scan-result.component.html',
  styleUrls: ['./scan-result.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ScanResultComponent implements OnDestroy {
  scanBadgeData: ScanBadgeData;
  selfClaimShare: ClaimSelfForAdmin;
  personnalDataShare: BlockArray[] = [];

  constructor(public scan: ScanService,
    public nav: NavigateService,
    public api: ApiService,
    public sync: SyncService,
    public device: DevicesService,
    private loader: LoaderService,
    private personnalDatas: PersonnalDatasService) {
    if(!this.scan.claimScanData || !this.scan.claims) {
      if(!this.scan.userScanData) {
        this.loader.loading(true, {type: 'warn', message: 'noIDinQR.error'}).then(() => {
          this.nav.toPerm('scan-result', 'scan', 'CAMERA');
        });
      } else {
        this.scanBadgeData = JSON.parse(this.scan.userScanData?.data?.aud);
        this.scanBadgeData.userId = this.scan.userScanData?.data?.sig;
        this.scanBadgeData.pi && this.api.place(this.scanBadgeData.pi, false).then((place: Place) => {
          this.scanBadgeData.img = place.b64Logo || '';
        });
      }
    }
    if(this.scan?.claimScanData && this.scan?.claimScanData?.some(claim => this.personnalDatas.isClaimTypeClaimSelf(claim.type))) {
      this.personnalDataShare = this.personnalDatas.transformClaimToSelfClaim(this.scan.claims as ClaimSelf[],
        undefined, true, true, false, false);
    }
  }

  ngOnInit() {
    this.device.isDevices('cordova') && ScreenOrientation.unlock().catch((err: any) => console.error('ScreenOrientation unlock failed', err));
  }

  checkAge(claim: Claim): { adult: boolean, countryAge: number } {
    const id: ClaimIdCard = JSON.parse(claim.serialized);
    const country: Country = envCountries().find(x => x.name === environment.country);
    return {adult: differenceInYears(new Date(), new Date(id.date_of_birth)) > country.age, countryAge: country.age};
  }

  canSeeRotate() {
    return this.scan.claims?.some(claim => (claim.type === this.api.ct.ID_CARD && this.scan.hasControl(this.api.ct.ID_CARD)) ||
      (claim.type === this.api.ct.DRIVING_LICENSE && this.scan.hasControl(this.api.ct.DRIVING_LICENSE)) ||
      (claim.type === this.api.ct.HEALTH_CARD && this.scan.hasControl(this.api.ct.HEALTH_CARD)) ||
      (claim.type === this.api.ct.TRANSPORT_CARD && this.scan.hasControl(this.api.ct.TRANSPORT_CARD)));
  }

  ngOnDestroy() {
    this.scan.claimScanData = undefined;
    this.scan.claims = undefined;
    this.scan.placeControlClaims = undefined;
    this.device.isDevices('cordova') && ScreenOrientation.lock({type: OrientationType.PORTRAIT}).catch((err: any) => console.error('ScreenOrientation lock failed', err));
  }

  protected readonly JSON = JSON;
}
